export default "__VITE_ASSET__hmvpSEW9__"